import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=45c39da1&scoped=true&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"
import style0 from "./collapse.vue?vue&type=style&index=0&id=45c39da1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c39da1",
  null
  
)

export default component.exports